module.exports = __webpack_public_path__ + "static/media/3795.6a85aaca.jpg";